// Returns the objects that leftArr contains and rightArr doesn't (i.e. leftArr - rightArr )
const isLandingPage = (path) => {
  if (!path) return false;
  return path.includes("/lp/");
};

module.exports = {
  isLandingPage
};
